<template>
  <div class="page withdraw-middle">
    <navigation @click="navigateTo('time')">{{title||'我要提现'}}</navigation>
    <img class="icon" src="./image/icon_tanhao01.png" alt="">
    <div class="title">{{labelValue}}</div>
    <div class="iconValue">
      <span :class="status==='unsatisfied'?'pl70':''">{{iconValue}}</span>
    </div>
    <div class="container">
      <div class="title">
        私信给你的小秘籍：
      </div>
      <div class="sub-title">
        {{contentValue}}
      </div>
      <nd-button class="repay" @click="navigateTo(nextNode)">{{buttonValue}}</nd-button>
    </div>
    <div @click="talk" class="talk" v-if="status==='aboutToExpire'">下次再说</div>
  </div>

</template>
<script>
import { hasNativeMethod, jsBridge } from '../../assets/jsBridge.js'
import { judgeClientSystem, isTMDMiniprogram } from '../../assets/utils'
import wx from 'weixin-webview-jssdk'
export default {
  name: 'withdraw-middle',
  data () {
    return {
      status: this.$route.query.status || 'unsatisfied',
      STATUS: {
        'unsatisfied': {
          key: 0,
          labelValue: '信用值不足，暂不支持再次申请',
          iconValue: '良好的还款行为有助于增加你的信用值哦～',
          contentValue: `当前仅需完成${this.$route.query.count || ''}次还款，即可获得再次申请的机会`,
          buttonValue: '去还款，立即申请'
        },
        'time': {
          key: 1,
          labelValue: '当前时间系统暂不支持申请',
          iconValue: `早上${this.$route.query.count && this.$route.query.count.split('-')[0]}点再来申请吧～`,
          contentValue: `${this.$route.query.count}发起申请，通过率更高哦～`,
          buttonValue: '回到首页'
        },
        'failed': {
          key: 2,
          labelValue: '身份信息验证失败，暂不支持申请',
          iconValue: '重新上传身份信息再来申请吧～',
          contentValue: '更新上传有效身份信息，更有机会申请成功!',
          buttonValue: '立即更新'
        },
        'expired': {
          key: 3,
          labelValue: '身份证信息已到期，需重新上传',
          iconValue: '重新上传身份信息再来申请吧～',
          contentValue: '更新上传有效身份信息，更有机会申请成功!',
          buttonValue: '重新上传'
        },
        'aboutToExpire': {
          key: 4,
          labelValue: `您的身份证信息${this.$route.query.count}天内即将过期`,
          iconValue: '更新身份信息，申请通过率更高～',
          contentValue: '更新上传有效身份信息，更有机会申请成功!',
          buttonValue: '立即更新'
        },
        'amountTooLow': {
          key: 5,
          labelValue: '目前可用额度过低，暂不支持提现',
          iconValue: '良好的还款行为有助于再次申请哦～',
          contentValue: `当前额度过低，完成1次还款再来申请提现吧～`,
          buttonValue: '去还款，立提现'
        },
        'tooMuchLoan': {
          key: 6,
          labelValue: '已达平台最大在途借款笔数',
          iconValue: '良好的还款行为有助于再次申请哦～',
          contentValue: `当前您已有${this.$route.query.count || ''}笔在途借款了哟～完成1笔借据还款，再来申请提现吧～`,
          buttonValue: '去还款，立提现'
        }
      },
      source: this.$route.query.source,
      loanPlatform: this.$route.query.loanPlatform, // 还款来源
      orderId: this.$route.query.orderId, // 订单id
      title: this.$route.query.title, // 标题
      isWxMiniprogram: isTMDMiniprogram()
    }
  },
  created () {
    this.buriedPoint(10002, this.status, 1)
  },
  destroyed () {
    this.buriedPoint(10002, this.status, 0)
  },
  computed: {
    labelValue () {
      return this.STATUS[this.status].labelValue
    },
    iconValue () {
      return this.STATUS[this.status].iconValue
    },
    contentValue () {
      return this.STATUS[this.status].contentValue
    },
    buttonValue () {
      return this.STATUS[this.status].buttonValue
    },
    nextNode () {
      switch (this.status) {
        case 'unsatisfied':
          return {
            h5: '/repayment',
            native: 'repayment',
            query: { type: 'TMD' }
          }
        case 'time':
          return {
            h5: '/',
            native: 'home'
          }
        case 'failed':
          return {
            h5: '/authentication/supplementaryOCR',
            native: 'supplementaryOCR',
            query: { status: 'failed' }
          }
        case 'expired':
          return {
            h5: '/authentication/supplementaryOCR',
            native: 'supplementaryOCR',
            query: { status: 'expired' }
          }
        case 'aboutToExpire':
          return {
            h5: '/authentication/supplementaryOCR',
            native: 'supplementaryOCR',
            query: { status: 'aboutToExpire' }
          }
        default:
          return {
            h5: '/repayment',
            native: 'repayment',
            query: { type: 'TMD' }
          }
      }
    }
  },
  methods: {
    navigateTo (path) {
      this.buriedPoint(10002, this.status)
      if (hasNativeMethod('navigateTo') &&
        !!path.native &&
        judgeClientSystem() !== 'IOS' &&
        !['XIESHANG'].includes(this.source)) {
          const query = path.query ? { status: path.query.status } : {}
          jsBridge('navigateTo', { path: path.native, exitCurrent: true, ...query })
      } else if (isTMDMiniprogram() && path.native === 'home') {
        wx.miniProgram.postMessage({
          data: { eventType: 'BACK_HOME' }
        })
        wx.miniProgram.navigateBack()
      } else {
        let source = this.source ? { source: this.source } : {}
        let orderId = this.orderId ? { orderId: this.orderId } : {}
        let loanPlatform = this.loanPlatform ? { loanPlatform: this.loanPlatform } : {}
        this.$router.replace({
          path: path.h5,
          query: { ...path.query, ...source, ...orderId, ...loanPlatform } || ''
        })
      }
    },
    // 下次再说
    talk () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: 'withdraw', exitCurrent: true })
      } else if (isTMDMiniprogram()) {
        wx.miniProgram.postMessage({ data: { eventType: 'ONELY_NAVIGATE_BACK' } })
        wx.miniProgram.navigateBack()
      } else {
        this.$router.push({
          path: '/withdraw/index',
          query: {
            isShow: true
          }
        })
      }
    },
    // 埋点
    buriedPoint (id, type, visible = 1) {
      this.$report({
        id,
        args: {
          screen: 'page_withdrawmiddle',
          type,
          visible
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/mixin.less";

  .page.withdraw-middle {
    position:relative;
    text-align: center;
    background: #FAFAFA;
    img.icon {
      width: 80px;
      height: 80px;
      margin-top: 123px;
    }
    .title {
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 48px;
      padding-top: 41px;
    }
    .iconValue {
      width: 600px;
      height: 91px;
      line-height: 91px;
      margin: 22px auto 0;
      background:url(./image/img_tishi@2x2.png);
      background-size: 100% 100%;
      .pl70{
            padding-left: 70px;
      }
      span{
        display: inline-block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        // width: 600px;
        padding: 0;
        margin:0;
        font-size: 24px;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF4633;
      }
    }
    .container {
      width: 600px;
      height: 464px;
      background-size: cover;
      background-image: url('./image/img_xinfeng.png');
      margin: 0 auto;
      margin-top: 75px;
      text-align: left;
      padding-top: 10px;
      .title  {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        margin-left:66px ;
      }
      .sub-title {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 40px;
        margin-top: 20px;
        margin-left:66px ;
        margin-right:66px;
      }
      .repay {
        margin: 0 auto;
        margin-top: 151px;
        width: 420px;
      }
    }
    .back  {
      margin: 0 auto;
      width: 320px;
      margin-top: 30px;
    }
    .talk{
      // width: 112px;
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      margin:38px auto 0;
      text-decoration:underline;
    }
  }
</style>